export default __webpack_public_path__ + "static/media/letterjumble_locked_crown.a1b47384.svg";